import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '../contexts/AuthContext';

const MESES = ['Janeiro','Fevereiro','Março','Abril','Maio','Junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'];

// Paleta marketing — roxo opaco
const COR_DESTAQUE = '#5C3D52';
const COR_HOJE = '#f59e0b';

// Adaptado do sistema-rh. As fotos locais ficam no backend RH (token diferente),
// então usamos só foto_drive_id (Google Drive público) ou placeholder.
function fotoUrl(f) {
  if (f.foto_drive_id) return `https://drive.google.com/uc?id=${f.foto_drive_id}`;
  return null;
}

export default function Aniversariantes() {
  const [lista, setLista] = useState([]);
  const [mes, setMes] = useState(new Date().getMonth() + 1);
  const [loading, setLoading] = useState(true);
  const [filiais, setFiliais] = useState([]);

  useEffect(() => { axios.get(`${API}/filiais`).then(res => setFiliais(res.data)).catch(() => {}); }, []);
  const nomeFilial = (codigo) => {
    const f = filiais.find(x => String(x.codigo) === String(codigo));
    return f ? f.nome : `Filial ${codigo}`;
  };

  useEffect(() => {
    setLoading(true);
    axios.get(`${API}/aniversariantes`, { params: { mes } })
      .then(res => setLista(res.data))
      .catch(() => setLista([]))
      .finally(() => setLoading(false));
  }, [mes]);

  const hoje = new Date().getDate();
  const mesAtual = new Date().getMonth() + 1;

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between mb-4 flex-wrap gap-2">
        <h4 className="fw-bold mb-0"><i className="bi bi-cake2 me-2" style={{ color: COR_DESTAQUE }}></i>Aniversariantes</h4>
        <select className="form-select" style={{ width: 'auto' }} value={mes} onChange={e => setMes(Number(e.target.value))}>
          {MESES.map((m, i) => <option key={i} value={i + 1}>{m}</option>)}
        </select>
      </div>

      {loading ? (
        <div className="d-flex justify-content-center py-5"><div className="spinner-border" style={{ color: COR_DESTAQUE }} /></div>
      ) : lista.length === 0 ? (
        <div className="card p-5 text-center text-muted">
          <i className="bi bi-emoji-smile" style={{ fontSize: '2rem', color: '#ccc' }}></i>
          <p className="mt-2 mb-0">Nenhum aniversariante em {MESES[mes - 1]}</p>
        </div>
      ) : (
        <div className="row g-3">
          {lista.map(f => {
            const nascMatch = f.data_nascimento ? String(f.data_nascimento).match(/^(\d{4})-(\d{2})-(\d{2})/) : null;
            const dia = nascMatch ? parseInt(nascMatch[3], 10) : null;
            const isHoje = dia === hoje && mes === mesAtual;
            const foto = fotoUrl(f);
            return (
              <div key={f.id} className="col-12 col-md-6 col-lg-4">
                <div className="card p-3 d-flex flex-row align-items-center gap-3"
                  style={{ borderLeft: isHoje ? `4px solid ${COR_HOJE}` : `4px solid ${COR_DESTAQUE}` }}>
                  {foto
                    ? <img src={foto} alt="" referrerPolicy="no-referrer"
                        style={{ width: 56, height: 56, borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }}
                        onError={e => { e.currentTarget.style.display = 'none'; e.currentTarget.nextSibling.style.display = 'flex'; }} />
                    : null}
                  <div style={{
                    width: 56, height: 56, borderRadius: '50%', flexShrink: 0,
                    background: '#ECE3E8', color: COR_DESTAQUE,
                    display: foto ? 'none' : 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: '1.4rem',
                  }}><i className="bi bi-person-fill"></i></div>
                  <div className="flex-grow-1 min-width-0">
                    <div className="fw-semibold" style={{ fontSize: '0.92rem' }}>{f.nome}</div>
                    <div className="text-muted" style={{ fontSize: '0.78rem' }}>
                      {f.cargo || '—'}{f.filial && <> · {nomeFilial(f.filial)}</>}
                    </div>
                    {dia && (
                      <div style={{ fontSize: '0.85rem', color: isHoje ? COR_HOJE : COR_DESTAQUE, fontWeight: 600 }}>
                        {isHoje ? '🎂 ' : ''}Dia {dia}
                      </div>
                    )}
                  </div>
                  {isHoje && <span className="badge bg-warning text-dark" style={{ fontSize: '0.7rem' }}>Hoje!</span>}
                </div>
              </div>
            );
          })}
        </div>
      )}
      <div className="text-muted mt-3" style={{ fontSize: '0.78rem' }}>
        {lista.length} aniversariante(s) em {MESES[mes - 1]}
      </div>
    </div>
  );
}
